import { api } from 'common';

import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate.tsx';
import { BlockSwitchField } from '../../ConfigFields/Switch.tsx';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';

export function FaxBlockFormFields() {
  const { value: isAttachDocumentCoversheetEnabled } = useSelectedNodeField<boolean>(
    'config.attachDocumoCoversheet'
  );
  return (
    <>
      <BlockValueTemplateField
        fieldName="config.fileReference"
        label="File Reference"
        required
        helperText="The file to fax in the format {type}:{identifier}"
      />
      <BlockValueTemplateField
        fieldName="config.faxNumber"
        label="Fax Number"
        required
        helperText="The fax number to send the file to"
      />
      <BlockSwitchField
        fieldName="config.attachDocumoCoversheet"
        label="Attach Documo Cover Page"
      />
      {isAttachDocumentCoversheetEnabled && (
        <>
          <BlockValueTemplateField
            fieldName="config.documoCoversheet.id"
            label="Documo Cover Page ID"
            helperText="The id of the Documo cover page to use"
          />
          <BlockValueTemplateField
            fieldName="config.documoCoversheet.recipientName"
            label="Recipient Name"
            helperText="The name of the recipient for the cover page (40 character limit)"
          />
          <BlockValueTemplateField
            fieldName="config.documoCoversheet.senderName"
            label="Sender Name"
            helperText="The name of the sender for the cover page (40 character limit)"
          />
          <BlockValueTemplateField
            fieldName="config.documoCoversheet.subject"
            label="Subject"
            helperText="The subject of the fax for the cover page (55 character limit)"
          />
          <BlockValueTemplateField
            fieldName="config.documoCoversheet.notes"
            label="Notes"
            helperText="Additional notes for the cover page (4000 character limit)"
          />
        </>
      )}
      <BlockSwitchField
        fieldName="config.runMode"
        label="Send as a Test Fax"
        toggleStates={{
          activeState: api.FlowDefinition.RunMode.Test,
          inactiveState: api.FlowDefinition.RunMode.Live,
        }}
      />
    </>
  );
}
